/**
 *
 * @module lineItemAttribute
 *
 */

import Check from 'check-types';
import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyString
} = Check.assert;

/**
 *
 * @class LineItemAttribute
 *
 */
export default class LineItemAttribute {

    /**
     *
     * @param {String} attributeName
     * @param {String} attributeValue
     * @throws {InvalidArgumentException}
     *
     */
    constructor(attributeName, attributeValue) {

        const errorMessage = {
            ctor: 'LineItemAttribute(attributeName, attributeValue)',
            get attributeName() {
                return `${this.ctor} attributeName be a String with length`;
            },
            get attributeValue() {
                return `${this.ctor} attributeValue should be a String with length`;
            }
        };

        nonEmptyString(attributeName, errorMessage.attributeName, InvalidArgumentException);
        nonEmptyString(attributeValue, errorMessage.attributeValue, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.attributeName = attributeName;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.attributeValue = attributeValue;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/lineItemAttribute.js